import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (ex) {
      setErr(formatApiErrorDetail(ex?.response?.data?.detail) || ex.message);
    }
  };

  return (
    <main className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-4" data-testid="forgot-page">
      <div className="w-full max-w-md glass rounded-3xl p-8 rise">
        <h1 className="font-display text-2xl font-bold mb-2">Reset your password</h1>
        {sent ? (
          <p className="text-sm text-slate-300" data-testid="forgot-success">If that email is registered, a reset link has been sent. Check your inbox.</p>
        ) : (
          <>
            <p className="text-sm text-slate-400 mb-5">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <div><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="bg-slate-900 border-slate-800 mt-1.5 h-11" /></div>
              {err && <p className="text-sm text-red-400">{err}</p>}
              <Button type="submit" data-testid="forgot-submit" className="w-full h-11 bg-white text-slate-950 hover:bg-slate-100 font-semibold">Send reset link</Button>
            </form>
          </>
        )}
        <p className="mt-5 text-center text-sm"><Link to="/login" className="text-cyan-400 hover:text-cyan-300">← Back to sign in</Link></p>
      </div>
    </main>
  );
}
